import { cancelBtn, labelStyle, inputStyle, modalOverlay, modalBox, modalHeader, closeBtn } from '../../styles/adminStyles';

const QUICK_TEMPLATES = [
  { title: '🎉 Özel İndirim!', body: 'Bugün tüm siparişlerde özel indirim fırsatını kaçırma!' },
  { title: '🔥 Sınırlı Süre!', body: 'Sınırlı süreliğine geçerli kampanyamızdan yararlan.' },
  { title: '👋 Seni Özledik!', body: 'Bir süredir sizi göremedik. Bugün özel bir teklifimiz var!' },
  { title: '🆕 Yeni Ürünler!', body: 'Menümüze yeni lezzetler eklendi. Hemen keşfet!' },
];

function NotificationFormModal({ notifForm, setNotifForm, notifSending, notifResult, users, onSend, onClose }) {
  return (
    <div style={modalOverlay}>
      <div style={{ ...modalBox, width: '500px' }}>
        <div style={modalHeader}>
          <h2 style={{ margin: 0, fontSize: '18px' }}>🔔 Bildirim Gönder</h2>
          <button onClick={onClose} style={closeBtn}>×</button>
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={labelStyle}>Hedef Kitle</label>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '8px' }}>
            {[
              { value: 'all', label: '👥 Tüm Kullanıcılar', color: '#111' },
              { value: 'new_user', label: '🆕 Yeni Kullanıcılar', color: '#111' },
              { value: 'user', label: '👤 Belirli Kullanıcı', color: '#111' },
            ].map(opt => (
              <button key={opt.value} onClick={() => setNotifForm(p => ({ ...p, targetType: opt.value, targetUserId: '' }))}
                style={{ padding: '10px 14px', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px', textAlign: 'left', border: `2px solid ${notifForm.targetType === opt.value ? opt.color : '#eee'}`, backgroundColor: notifForm.targetType === opt.value ? opt.color + '12' : 'white', color: notifForm.targetType === opt.value ? opt.color : '#555' }}>
                {opt.label}
              </button>
            ))}
          </div>
          {notifForm.targetType === 'user' && (
            <select style={inputStyle} value={notifForm.targetUserId} onChange={e => setNotifForm(p => ({ ...p, targetUserId: e.target.value }))}>
              <option value="">Kullanıcı Seçin</option>
              {users.filter(u => u.fcmToken && !u.isAdmin).map(u => <option key={u.id} value={u.id}>{u.name || u.email} ({u.email})</option>)}
            </select>
          )}
          {notifForm.targetType === 'all' && <div style={{ fontSize: '12px', color: '#111', padding: '8px', backgroundColor: '#f9f9f9', borderRadius: '6px' }}>{users.filter(u => u.fcmToken && !u.isAdmin).length} kullanıcıya gönderilecek</div>}
          {notifForm.targetType === 'new_user' && <div style={{ fontSize: '12px', color: '#111', padding: '8px', backgroundColor: '#E8F0EA', borderRadius: '6px' }}>Henüz sipariş vermemiş kullanıcılara gönderilecek</div>}
        </div>

        <div style={{ marginBottom: '14px' }}>
          <label style={labelStyle}>Bildirim Başlığı *</label>
          <input style={inputStyle} placeholder="Örn: 🎉 Özel Fırsat!" value={notifForm.title} onChange={e => setNotifForm(p => ({ ...p, title: e.target.value }))} />
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={labelStyle}>Bildirim Mesajı *</label>
          <textarea style={{ ...inputStyle, height: '80px', resize: 'vertical' }} placeholder="Örn: Bugün tüm siparişlerde %20 indirim! Hemen sipariş ver." value={notifForm.body} onChange={e => setNotifForm(p => ({ ...p, body: e.target.value }))} />
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={labelStyle}>Hızlı Şablonlar</label>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
            {QUICK_TEMPLATES.map((tmpl, i) => (
              <button key={i} onClick={() => setNotifForm(p => ({ ...p, title: tmpl.title, body: tmpl.body }))}
                style={{ padding: '5px 10px', fontSize: '12px', borderRadius: '20px', border: '1px solid #ddd', backgroundColor: 'white', cursor: 'pointer', color: '#111' }}>
                {tmpl.title}
              </button>
            ))}
          </div>
        </div>

        {notifResult && (
          <div style={{ padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', backgroundColor: notifResult.success ? '#E3F3E9' : '#FBE9E7', color: notifResult.success ? '#1E7A45' : '#B3261E', fontWeight: '600', fontSize: '14px' }}>
            {notifResult.success ? '✅ ' : '❌ '}{notifResult.message}
          </div>
        )}

        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={onClose} style={cancelBtn}>Kapat</button>
          <button onClick={onSend} disabled={notifSending} style={{ flex: 2, padding: '10px', backgroundColor: '#1F4A33', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '14px', opacity: notifSending ? 0.7 : 1 }}>
            {notifSending ? 'Gönderiliyor...' : '🔔 Bildirimi Gönder'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotificationFormModal;
